export enum DeliveryType {
  SMS = 'SMS',
  MOBILE_PUSH = 'MOBILE_PUSH',
  EMAIL = 'EMAIL',
  RAWEMAIL = 'RAWEMAIL',
}

export enum SubscribedStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  POSTPONED = 'POSTPONED',
}

/** @deprecated */
export enum MessagePlaceholders {
  TIMESTAMP = 'TIMESTAMP',
  TYPE = 'TYPE',
  NAME = 'NAME',
  GROUP = 'GROUP',
  ATTRIBUTE = 'ATTRIBUTE',
  VALUE = 'VALUE',
  MAX = 'MAX',
  MIN = 'MIN',
  STANDARD_DEVIATION = 'STANDARD_DEVIATION',
  DURATION = 'DURATION',
  UNIT = 'UNIT',
}
